import React from "react";
import {Button, Form, Image, Input, Upload} from "@pankod/refine-antd";

interface CoverImageSectionProps {
    coverImageUrl?: string;
    uploading: boolean;
    generating: boolean;
    aiPrompt: string;
    setAiPrompt: (v: string) => void;
    showAiPrompt: boolean;
    setShowAiPrompt: (v: boolean) => void;
    buildDefaultPrompt: () => string;
    handleUpload: (info: any) => void;
    handleGenerateImage: () => void;
    canGenerate: boolean;
}

/**
 * Shared cover image section with upload + AI generation UI.
 * Used by both ProductBundleCreate and ProductBundleEdit.
 */
export const CoverImageSection: React.FC<CoverImageSectionProps> = ({
    coverImageUrl,
    uploading,
    generating,
    aiPrompt,
    setAiPrompt,
    showAiPrompt,
    setShowAiPrompt,
    buildDefaultPrompt,
    handleUpload,
    handleGenerateImage,
    canGenerate,
}) => {
    const defaultPrompt = buildDefaultPrompt();

    return (
        <Form.Item label="Cover Image">
            {coverImageUrl && (
                <div style={{marginBottom: 8}}>
                    <Image width={120} src={coverImageUrl} />
                </div>
            )}
            <div style={{display: "flex", gap: 8, marginBottom: 8}}>
                <Upload
                    maxCount={1}
                    showUploadList={false}
                    customRequest={handleUpload}
                    accept="image/*"
                >
                    <Button loading={uploading}>Upload Image</Button>
                </Upload>
                <Button
                    loading={generating}
                    onClick={() => setShowAiPrompt(!showAiPrompt)}
                >
                    Generate with AI
                </Button>
            </div>
            {showAiPrompt && (
                <div style={{marginBottom: 8}}>
                    <Input.TextArea
                        rows={4}
                        value={aiPrompt || defaultPrompt}
                        onChange={(e) => setAiPrompt(e.target.value)}
                        placeholder="Describe the image you want to generate..."
                    />
                    <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: 4, gap: 8}}>
                        {aiPrompt && (
                            <Button
                                size="small"
                                type="text"
                                onClick={() => setAiPrompt("")}
                            >
                                Reset to default
                            </Button>
                        )}
                        <Button
                            type="primary"
                            loading={generating}
                            onClick={handleGenerateImage}
                            disabled={!canGenerate}
                        >
                            {generating ? "Generating..." : "Generate"}
                        </Button>
                    </div>
                </div>
            )}
        </Form.Item>
    );
};
